
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'perso-3': {
    width: 41.9,
    height: 105.8,
    viewBox: '0 0 41.9 105.8',
    data: '<path pid="0" d="M3.3 99.9l2.4-3.2 1.1-16.3L14.4 55l11.1 21.6L29.9 97l3.5 5.8M3 3l3.5 12.9 3.8 12.8 12.3 1.8 10.8-10.6 5.5-11.3" _fill="none" _stroke="#fc0f3a" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/><path pid="1" d="M13.5 14.4L17 25.8l-2 21.6-1.2 11.4" _fill="none" _stroke="#fc0f3a" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"/>'
  }
})
